import { DatePickerSingleGroup, DeclarantLanguage } from '@/common'
import { format } from 'date-fns'
import { Matcher } from 'react-day-picker'
import { useDates } from '@/shared/hooks/useDates'
import useI18n from '@/shared/hooks/usei18n'

export default function DeclarantDatePickerSingle({
  id,
  date,
  label,
  disabled,
  disabledInput,
  onChange,
  startMonth,
  required,
  endMonth,
  placeholder
}: {
  disabled?: Matcher | Matcher[] | null
  startMonth?: Date
  endMonth?: Date
  date?: string
  required?: boolean
  onChange: (date: string) => void
  id: string
  label?: string
  placeholder?: string
  disabledInput?: boolean
}) {
  const currentLanguage = useI18n().currentLanguage as DeclarantLanguage

  const { standardFormat, locale } = useDates(currentLanguage)

  const handleChange = (selectedDate: Date | null) => {
    const standardFormattedDate = selectedDate ? format(selectedDate, standardFormat) : ''

    onChange(standardFormattedDate)
  }

  return (
    <DatePickerSingleGroup
      id={id}
      placeholder={placeholder}
      date={date ? new Date(date) : undefined}
      label={label}
      disabled={disabled || undefined}
      disabledInput={disabledInput}
      onChange={handleChange}
      startMonth={startMonth}
      endMonth={endMonth}
      locale={locale}
      required={required}
    />
  )
}
